<mat-card appearance="outlined" class="card">
  @if (!customer) {
  <mat-card-title mat-dialog-title i18n
    >Select Assigned Customers</mat-card-title
  >
  <mat-card-content>
    <app-customer-selection (customerSelected)="onCustomerSelected($event)"
     />
  </mat-card-content>
  } @else {
  <p style="color: #2c2c2c; font-size: 1.2em" i18n="@@selectedCustomer">
    Selected customer:
  </p>
  <app-customer-card [customer]="customer"
    (clearSelection)="clearCustomer()"
   />
  <br />
  <mat-card-actions>
    <div class="flex-row end-center gap-20" mat-dialog-actions>
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="elevated"
        color="accent"
        (click)="onSave()"
        [disabled]="!customer"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </div>
  </mat-card-actions>
  }
</mat-card>
